import { render, staticRenderFns } from "./BetsOnRace.vue?vue&type=template&id=e2386bea&"
import script from "./BetsOnRace.vue?vue&type=script&lang=js&"
export * from "./BetsOnRace.vue?vue&type=script&lang=js&"
import style0 from "./BetsOnRace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports